export default "__VITE_ASSET__i7J7O_wF__"